document.addEventListener("DOMContentLoaded", function () {
  var currentItem = document.getElementById("current-item");
  if (currentItem) {
    var rect = currentItem.getBoundingClientRect();
    var isVisible =
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth);

    if (!isVisible) {
      var currentIndex = parseInt(currentItem.getAttribute("data-index"), 10);
      var maxAttempts = 10; // Set a maximum number of attempts to prevent infinite loop
      var attempts = 0;

      function navigateToItem() {
        attempts++;

        var visibleItems = document.querySelectorAll(".collection-items");
        var lastVisibleIndex = -1;

        // Check which items are actually visible in the viewport
        visibleItems.forEach(function (item) {
          var itemRect = item.getBoundingClientRect();
          var itemIsVisible =
            itemRect.top >= 0 &&
            itemRect.left >= 0 &&
            itemRect.bottom <=
              (window.innerHeight || document.documentElement.clientHeight) &&
            itemRect.right <=
              (window.innerWidth || document.documentElement.clientWidth);
          if (itemIsVisible) {
            lastVisibleIndex = parseInt(item.getAttribute("data-index"), 10);
          }
        });

        if (currentIndex > lastVisibleIndex && attempts <= maxAttempts) {
          var closestSlideSection = currentItem.closest("slide-section");
          if (closestSlideSection) {
            var closestNextButton = closestSlideSection.querySelector(
              'button[data-controls="next"]'
            );
            if (closestNextButton) {
              closestNextButton.click();
              setTimeout(navigateToItem, 75); // Adjust the timeout as needed
            } else {
              console.error("Next button not found");
            }
          } else {
            console.error("Closest slide-section not found");
          }
        } else {
          currentItem.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }

      // Delay to ensure buttons are loaded
      setTimeout(function () {
        navigateToItem();
      }, 750); // Adjust the delay as needed
    }
  }
});
